export const DISPLAY_LOGIN_LOADING = 'DISPLAY_LOGIN_LOADING';
export const HIDE_LOGIN_LOADING = 'HIDE_LOGIN_LOADING';
